import { render } from "./LoaderModal.vue?vue&type=template&id=6880b4ff&scoped=true"
import script from "./LoaderModal.vue?vue&type=script&lang=js"
export * from "./LoaderModal.vue?vue&type=script&lang=js"

import "./LoaderModal.vue?vue&type=style&index=0&id=6880b4ff&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6880b4ff"]])

export default __exports__